import { atom } from "recoil";

export type LoginMethod = "apple" | "google" | "kakao";

// 웹 퍼널에서 OneLink(딥링크)로 전달된 "최근 로그인" provider 힌트.
// 네이티브 브리지(event: "lastLoginMethod")로만 세팅되며 영속 저장하지 않는다.
// → 앱 WebView 에서 OneLink 로 전달받은 경우에만 로그인 버튼에 라벨이 뜬다.
export const loginHintAtom = atom<LoginMethod | undefined>({
  key: "loginHint",
  default: undefined,
});
